module.exports = __webpack_public_path__ + "img/ENERGIE_DICI_80X30.00306f00.png";